/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from '../../../types/types';

export const messages: SegmentSpecificMessages = {
    emailExplanation: 'Needed to send you your unique code',
    schoolName: '', // N/A
    step: {
        personalInfo: {
            subtitle: "Verify you're a licensed medical professional.",
            howDoesVerifyingWorkDetails: `To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States 
                    and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status 
                    selector of this form.<br><br>{company} uses SheerID, a trusted partner, to verify that you are a medical professional. 
                    SheerID only collects information that assists in verifying your eligibility. 
                    Additional information or documentation may be requested.`,
            tryAgain: {
                title: 'Check Your Name, Postal Code, Birthdate & Organization',
                subtitle: 'Your full name, organization name, postal code, and birthdate must match what is on record with your licensing body.',
            },
        },
        docUpload: {
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying 
                    medical professionals.<br><br>Documents are used only for verifying your medical professional status is 
                    current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.`,
            uploadInstructions: 'Upload an official document that shows',
        },
    },
};
